module.exports = __webpack_public_path__ + "img/Cramo_Logo+289x289.f59fcdfc.png";